import React from "react";

const handleUpdate = (e, field, update) => {
  if (!field) {
    update(e.target.checked);
  } else {
    update((o) => {
      let u = { ...o };
      u[field] = e.target.checked;
      return u;
    });
  }
};

export default function CheckBox({
  label,
  value,
  field,
  update,
  className = "",
  labelClassName = "",
  ...props
}) {
  return (
    <div className="relative">
      <div
        className={`flex flex-row my-1 w-full ${className}`}
      >
        {label && 
          <label className={`font-bold text-secondary mr-4 ${labelClassName}`}>
            {label}
          </label>
        }
        <input
          type="checkbox"
          checked={
            !!field
              ? !!value && !!value[field]
                ? value[field]
                : false
              : !!value
              ? value
              : false
          }
          onChange={(e) => handleUpdate(e, field, update)}
          className="px-3 text-white bg-transparent"
          {...props}
        />
      </div>
    </div>
  );
}
